export default {
    root: {
        marginRight: 0
    }
};
